import { createAction } from '@reduxjs/toolkit';

import { staffReducerTypes } from 'types';

export const STAFF_DATA_SAGA = 'STAFF_DATA_SAGA';
export const staffDataSaga = createAction<staffReducerTypes.IStaffDataForm>(STAFF_DATA_SAGA);

export const STAFF_DATA_UPDATE_SAGA = 'STAFF_DATA_UPDATE_SAGA';
export const staffDataUpdateSaga = createAction<staffReducerTypes.IStaffDataUpdateForm>(STAFF_DATA_UPDATE_SAGA);
